import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScatteredConnectors = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1120 560",
	fill: "none",
	preserveAspectRatio: "none",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeDasharray: "5 7",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		vectorEffect: "non-scaling-stroke",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M300 170 C 420 170, 430 280, 560 280" }),
			/* @__PURE__ */ _jsx("path", { d: "M800 110 C 700 110, 690 280, 560 280" }),
			/* @__PURE__ */ _jsx("path", { d: "M440 430 C 470 360, 500 280, 560 280" }),
			/* @__PURE__ */ _jsx("path", { d: "M810 400 C 720 400, 650 280, 560 280" })
		]
	})
});
export default SvgScatteredConnectors;
